<template>


  <div class="page_container">

    <div class="yingbi_quantity">{{ totalCoinCount }}</div>
    
    
    
    <div class="yiingbi_quantity_text_layout">
      <img :src="require('@/assets/yingbi.png')"  @click="handleJingxin1" class="yiingbi_quantity_text_layout_img" />
      <div class="yiingbi_quantity_text_layout_text" style="margin-left: 0.1rem;" @click="handleJingxin2">硬币余额</div>
    </div>

    <div class="get_yingbi_layout" @click="toGetyingBiPage">
      <div class="get_yingbi_layout_left">硬币是什么，如何使用和获取？</div>
      <div class="get_yingbi_layout_right">获取硬币</div>
    </div>
    <div class="yingbi_detail">
      <div class="yingbi_detail_text">硬币明细</div>

      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :offset="15"
          class="yingbi_detail_list"
        >
          <YingBiItems :items="items" />

          
        </van-list>
      </van-pull-refresh>
      

    <div>
    
  </div>
      



    </div>

  </div>

  
 



  
  

  
    
  </template>
  
  <script setup >
  import { ref, onMounted } from 'vue';

  import {getUserCoinInfoListPagedById,getUserCoinCount} from '@/api/apiService';

 


  // loginByUnionid, 

  // import { LoginRequest } from '@/types/types';

  import YingBiItems from '@/components/YingBiItems.vue';
  import { useRouter } from 'vue-router';

  const router = useRouter();

  const items = ref([]);


  const page = ref(0); // 当前页码
  const pageSize = 20; // 每页条数
  const loading = ref(false); // 加载状态
  const finished = ref(false); // 是否已加载完成
  const refreshing = ref(false); // 刷新状态
  const totalCoinCount = ref(0); // 刷新状态

  const click1times = ref(0);

  



  


  function toGetyingBiPage() {
    // router.push({ name: 'GetYingBi' });
    const url = router.resolve({ name: 'GetYingBi' }).href;
    window.location.href = url;
  }



  const deleteClicks = ref(new Map());

  function handleJingxin1() {

    deleteClicks.value = new Map([[1, deleteClicks.value.get(1) || []]]);

  const clicks = deleteClicks.value.get(1) || [];
  

  clicks.push(Date.now());
  // if (clicks.length > 5) clicks.shift();
  deleteClicks.value.set(1, clicks);
  click1times.value +=1;

  


    
  }




  function handleJingxin2() {
    if(click1times.value!=5){
      return;
    }

    deleteClicks.value = new Map([[2, deleteClicks.value.get(2) || []]]);

  const clicks = deleteClicks.value.get(2) || [];
  

  clicks.push(Date.now());
  // if (clicks.length > 5) clicks.shift();
  deleteClicks.value.set(2, clicks);

  if (clicks.length === 5 && clicks[4] - clicks[0] <= 12000) {


        router.push({ name: 'AdminLogin' });

  }


    
  }
  

  // const unionId = ref('testid');

// async function login() {
//   try {
//     const loginInfo = new LoginRequest(unionId.value, 'password');
//     const response = await loginByUnionid(loginInfo);
//     console.log('Login successful:', response);
//   } catch (error) {
//     console.error('Login failed:', error);
//   }
// }

// function delay(ms) {
//   return new Promise(resolve => setTimeout(resolve, ms));
// }


// 获取硬币总数
async function getUserTotalCoinCount() {
  try {
    const response = await getUserCoinCount();
    if (response.code === 0 && response.msg === 'success') {
      totalCoinCount.value = response.totalCoin;
    } else {
      router.replace({ name: 'Wrong' }); // 跳转到错误页面并删除栈内所有页面
    }
  } catch (error) {
    
    router.replace({ name: 'Wrong' }); // 跳转到错误页面并删除栈内所有页面
    
  }
}



async function fetchCoinInfo(reset = false) {
  try {
    if (reset) {
      page.value = 0;
      items.value = [];
      finished.value = false;

      
    }
    page.value += 1; // 否则页码加1
    const pageParams = { page: page.value, size: pageSize };
    const response = await getUserCoinInfoListPagedById(pageParams);
    if (response.code === 0 && response.msg === 'success') {
      
      
      items.value = [...items.value, ...response.useCoinInfo.records]; // 将新数据追加到 items 中
      if (response.useCoinInfo.records.length < pageSize) {
        finished.value = true; // 如果返回的数据条数少于 pageSize，表示已加载完成
        
      }
      
    } else {
      router.replace({ name: 'Wrong' }); // 跳转到错误页面并删除栈内所有页面
    }
  } catch (error) {
    router.replace({ name: 'Wrong' }); // 跳转到错误页面并删除栈内所有页面
    
    
    
  } finally {
    // console.log('refreshing:', refreshing.value);
    
   
    if (reset) {

      refreshing.value = false;
      
      

      
    } else {
      loading.value = false; // 结束加载状态
      
    }
  }
}



// 下拉刷新
function onRefresh() {
 


  fetchCoinInfo(true);
 
  
}

// 上拉加载
function onLoad() {

  
  
  fetchCoinInfo();
}





  
    


    // 在组件加载时调用 login() 方法
    onMounted(() => {


      getUserTotalCoinCount();

     
      
    });
  
  

   


  




  </script>
  
  <style scoped>

  

  .page_container {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    
  }

  .yingbi_quantity {
    font-size: 1.0rem;
    margin-top: 0.8rem;
    
    display: flex;
    text-align: center;
    align-items: center;

  }

  .yiingbi_quantity_text_layout {
    display: flex;
    flex-direction: row;

    margin-bottom: 0.4rem;
    
    
    align-items: center;
    
  }

  .yiingbi_quantity_text_layout_img {
    display: flex;
    
    height: 0.5rem;
    
    margin-top: 0.2rem;
  }
  .yiingbi_quantity_text_layout_text {
    display: flex;
    
    margin-top: 0.2rem;
    
    font-size: 0.5rem;
  }


  .get_yingbi_layout {
    display: flex;
    flex-direction: row;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    
    width: 95%;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    align-items: center; /* 垂直居中对齐 */
    justify-content: space-between; /* 水平居中对齐 */
    border-radius: 0.5rem; /* 设置圆角 */
    background-color: #ededed; /* 设置背景色 */

  }

  .get_yingbi_layout_left {
    text-align: left;
    font-size: 0.4rem;
    margin-left: 0.6rem;
    
    
  }
  .get_yingbi_layout_right {
    text-align: right;
    font-size: 0.4rem;
    margin-right: 0.6rem;
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
    padding-left: 0.2rem;
    padding-right: 0.2rem;
    color: white;

    border-radius: 0.5rem; /* 设置圆角 */
    background-color: #0C84FF; /* 设置背景色 */
    
    
  }

  .yingbi_detail {
    display: flex;
    flex-direction: column;
    
    width: 95%;
    
    margin-bottom: 0.8rem;
  }

  .yingbi_detail_text {
    font-size: 0.5rem;
    margin-left: 0.4rem;
    text-align: left;
    margin-bottom: 0.2rem;
    font-weight: bold;
  }

  .yingbi_detail_list {
    margin-left: 0.4rem;
    margin-right: 0.4rem;
    
    margin-bottom: 0.8rem;
  }





 
  






  </style>